module.exports = __webpack_public_path__ + "assets/img/img-gzh-e305177b.png";